import { get, isArray, reduce, isString, isObject, set } from 'lodash';
import { parseConnectionString } from './connections';
import { Resource } from './resource';
function asResponse(value, options) {
    if (options?.path) {
        value = get(value, options.path);
    }
    if (options?.map && isString(options.key) && isArray(value)) {
        const key = options.key;
        value = reduce(value, (m, v) => set(m, get(v, key), v), {});
    }
    if (options?.asResource && isObject(value)) {
        return new Resource(value);
    }
    return value;
}
function getCacheKey(operation, options) {
    let extras = '';
    if (options?.parameters) {
        extras = reduce(options.parameters, (m, v, k) => `${m}&${v}=${k}`);
    }
    return (isString(operation) ? operation : operation.url) + extras;
}
export class Repository {
    connections;
    cache;
    constructor(conn) {
        this.connections = conn;
        this.cache = {};
    }
    get(operation, options) {
        const cacheKey = getCacheKey(operation, options);
        const self = this;
        if (!(cacheKey in this.cache)) {
            this.cache[cacheKey] = new Promise((resolve, reject) => {
                if (isString(operation)) {
                    options = options || {
                        asResource: false,
                        asResourceContainer: false
                    };
                    const cn = parseConnectionString(operation);
                    const conn = this.connections.getConnection(cn.connection);
                    return conn
                        .request(operation, options)
                        .then(response => onResponse(response))
                        .catch(reject);
                }
                const conn = this.connections.default;
                const url = `${conn.config.baseUrl}${operation.url}`;
                return this.connections
                    .ajax(url, options)
                    .then(response => onResponse(response))
                    .catch(reject);
                function onResponse(response) {
                    if (response.status === 204) {
                        return resolve(null);
                    }
                    return resolve(response.data);
                }
            });
        }
        return Promise.resolve(self.cache[cacheKey]).then((data) => asResponse(data, options));
    }
    clearCache(operation, options) {
        const cacheKey = getCacheKey(operation, options);
        if (cacheKey in this.cache) {
            delete this.cache[cacheKey];
        }
    }
    resetCache(prefix) {
        for (let k of Object.keys(this.cache)) {
            if (prefix == null || k.startsWith(prefix)) {
                delete this.cache[k];
            }
        }
    }
}
//# sourceMappingURL=repo.js.map